import api from '../../index'

export async function remove(id: string, email: string) {
  try {
    const response = await api.instance.delete(
      `/organizations/${id}/members/${email}`
    )

    return response.data
  } catch (error) {
    throw error
  }
}

export async function invite(
  id: string,
  payload: {
    email: string
  }
) {
  try {
    const response = await api.instance.post(`/organizations/${id}/members`, {
      email: payload.email,
      role: 'member',
    })

    return response.data
  } catch (error) {
    throw error
  }
}
